/**
 * Resolve selected stats rows (tracker listId + name) to catalog wiserIds.
 * Same matching order as resolveTagsForListRow: voluumId case-insensitive
 * first, then trimmed lowercase name equality. Rows without a catalog match
 * are reported so the dialog can say they will be skipped.
 * For Media Devoted | Created By Ciro Autiero
 */

export interface WiserIdResolution {
  wiserIds: number[];
  unresolved: string[];
}

export function resolveWiserIds(
  rows: Array<{ listId?: string | number; listName?: string }>,
  leadsLists: Array<{ id: number; name?: string; voluumId?: string | null }>,
): WiserIdResolution {
  const wiserIds = new Set<number>();
  const unresolved: string[] = [];

  for (const row of rows) {
    const listId = row.listId != null ? String(row.listId).trim().toLowerCase() : '';
    const listName = row.listName?.trim().toLowerCase() ?? '';

    const lead =
      (listId &&
        leadsLists.find(
          (l) => l.voluumId?.trim().toLowerCase() === listId,
        )) ||
      (listName &&
        leadsLists.find(
          (l) => (l.name ?? '').trim().toLowerCase() === listName,
        )) ||
      null;

    if (lead) wiserIds.add(lead.id);
    else unresolved.push(row.listName?.trim() || String(row.listId ?? '—'));
  }

  return { wiserIds: [...wiserIds], unresolved };
}
